import moment from "moment";
import {WizClassifySelect} from "../../index";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const _getValue= (type, key) => {
  const values = {
    examType: {
      '0':'独立考试',
      '1':'课程考试',
      '2':'练习考试'
    }
  }
  return values[type][key]
}

let examTypeDict =[
  { code: 0, codeName: '独立考试' },
  { code: 1, codeName: '课程考试' },
  { code: 2, codeName: '练习考试' },
]

const columns = (api = {}) => {
  let disabled = false
  let examTypes = api.apiParams?.examTypes || []
  if (examTypes.length > 1) {
    examTypeDict = [
      { code: 0, codeName: '独立考试' },
      { code: 1, codeName: '课程考试' },
    ]
  } 
  if (examTypes.length == 1) {
    disabled = true
    examTypeDict = [
      { code: 2, codeName: '练习考试' },
    ]
  }
  return [
    {
      title: "模版名称",
      name: "title",
      dataIndex: "title",
      tableItem: {width:300 },
      searchItem: {
      },
    },
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "考试分类",
      name: "categoryTypeIds",
      dataIndex: "categoryTypeIds",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          itemProps: {
            icon: 'unordered-list',
            title: '考试分类',
            tips: '请选择考试分类'
          },
          treeProps: { checkStrictly: true },
          checkable: false
        },
        apiProps: { type: 0 },
        selectProps: {
          placeholder: '请选择考试分类'
        }
      }
    },
    {
      title: "考试分类",
      name: "categoryType",
      dataIndex: "categoryType",
      tableItem: {width:300 },
    },
    {
      title: "考试类型",
      name: "examTypes",
      dataIndex: "examTypes",
      searchItem: { 
        type: 'select',
        mode: 'multiple',
        initialValue: api.apiParams?.examTypes,
        disabled: disabled
      },
      dict: examTypeDict,
      tableItem: { 
        width: 160,
        render: (text, record) => {
          return text.map(et => 
            _getValue('examType',et)
          ).join('、')
        }
      },
    },
    {
      title: "创建时间",
      name: "createTime",
      dataIndex: "createTime",
      tableItem: {
        width: 200,
        render: (text) => {
          return formatterDate(text)
        }
      },
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'examTemplate/listByPage',
    ...api
  }
}

const examTemp = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'title',
    columns: columns(api),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default examTemp
